(function () {
  document.addEventListener(
    'play',
    function (e) {
      var target = e.target;
      if (target.tagName !== 'VIDEO') return;
      var root = target.closest('[data-product-ugc-reels]');
      if (!root) return;
      root.querySelectorAll('video').forEach(function (video) {
        if (video !== target && !video.classList.contains('product-ugc-modal__video')) {
          video.pause();
        }
      });
    },
    true
  );

  function getRoot(modalOrRoot) {
    if (modalOrRoot.matches && modalOrRoot.matches('[data-product-ugc-reels]')) {
      return modalOrRoot;
    }

    var sectionId = modalOrRoot.dataset.ugcSectionId;
    if (sectionId) {
      return document.querySelector(
        '[data-product-ugc-reels][data-ugc-section-id="' + sectionId + '"]'
      );
    }

    return modalOrRoot.closest('[data-product-ugc-reels]');
  }

  function getSlides(modal) {
    var root = getRoot(modal);
    if (!root) return [];
    return Array.from(root.querySelectorAll('.product-ugc-reels__slide'));
  }

  function copyVideoToModal(sourceVideo, modalVideo, shouldAutoplay) {
    modalVideo.innerHTML = '';
    sourceVideo.querySelectorAll('source').forEach(function (source) {
      modalVideo.appendChild(source.cloneNode(true));
    });

    if (sourceVideo.src) {
      modalVideo.src = sourceVideo.src;
    }

    var poster = sourceVideo.getAttribute('poster');
    if (poster) {
      modalVideo.setAttribute('poster', poster);
    } else {
      modalVideo.removeAttribute('poster');
    }

    modalVideo.muted = sourceVideo.muted;
    modalVideo.load();

    var resumeAt = shouldAutoplay ? 0 : sourceVideo.currentTime || 0;

    function applyResumeTime() {
      modalVideo.currentTime = resumeAt;
      if (shouldAutoplay) {
        modalVideo.play().catch(function () {});
      }
    }

    if (modalVideo.readyState >= 1) {
      applyResumeTime();
    } else {
      modalVideo.addEventListener('loadedmetadata', applyResumeTime, { once: true });
    }
  }

  function updateNavButtons(modal, index, total) {
    var prevButton = modal.querySelector('[data-ugc-prev]');
    var nextButton = modal.querySelector('[data-ugc-next]');

    if (prevButton) {
      prevButton.disabled = index <= 0;
    }

    if (nextButton) {
      nextButton.disabled = index >= total - 1;
    }
  }

  function pauseCarouselVideos(root) {
    if (!root) return;
    root.querySelectorAll('.product-ugc-reels__video').forEach(function (video) {
      video.pause();
    });
  }

  function showSlideInModal(modal, index, shouldAutoplay) {
    var slides = getSlides(modal);
    if (!slides.length) return;

    var nextIndex = Math.max(0, Math.min(index, slides.length - 1));
    var slide = slides[nextIndex];
    var sourceVideo = slide.querySelector('.product-ugc-reels__video');
    var modalVideo = modal.querySelector('.product-ugc-modal__video');
    var root = getRoot(modal);

    if (!sourceVideo || !modalVideo) return;

    pauseCarouselVideos(root);
    copyVideoToModal(sourceVideo, modalVideo, shouldAutoplay === true);
    modal.dataset.activeIndex = String(nextIndex);
    updateNavButtons(modal, nextIndex, slides.length);

    var track = root ? root.querySelector('.product-ugc-reels__track') : null;
    if (track && typeof slide.scrollIntoView === 'function') {
      slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  }

  function openModal(modal, slide, opener) {
    var slides = getSlides(modal);
    var index = slides.indexOf(slide);
    if (index < 0) return;

    showSlideInModal(modal, index, false);
    modal.show(opener);

    var modalVideo = modal.querySelector('.product-ugc-modal__video');
    if (modalVideo) {
      modalVideo.play().catch(function () {});
    }
  }

  document.addEventListener('click', function (e) {
    var expandButton = e.target.closest('[data-ugc-expand]');
    if (expandButton) {
      e.preventDefault();
      e.stopPropagation();

      var slide = expandButton.closest('.product-ugc-reels__slide');
      var modalId = expandButton.getAttribute('aria-controls');
      var modal = modalId ? document.getElementById(modalId) : null;

      if (!modal || !slide || typeof modal.show !== 'function') return;

      openModal(modal, slide, expandButton);
      return;
    }

    var prevButton = e.target.closest('[data-ugc-prev]');
    var nextButton = e.target.closest('[data-ugc-next]');
    var navButton = prevButton || nextButton;

    if (!navButton || navButton.disabled) return;

    var modal = navButton.closest('.product-ugc-modal');
    if (!modal || !modal.hasAttribute('open')) return;

    e.preventDefault();

    var currentIndex = parseInt(modal.dataset.activeIndex || '0', 10);
    showSlideInModal(modal, prevButton ? currentIndex - 1 : currentIndex + 1, true);
  });

  document.addEventListener('keydown', function (e) {
    var modal = document.querySelector('.product-ugc-modal[open]');
    if (!modal) return;

    if (e.key === 'ArrowLeft') {
      var prevButton = modal.querySelector('[data-ugc-prev]');
      if (prevButton && !prevButton.disabled) {
        e.preventDefault();
        prevButton.click();
      }
    }

    if (e.key === 'ArrowRight') {
      var nextButton = modal.querySelector('[data-ugc-next]');
      if (nextButton && !nextButton.disabled) {
        e.preventDefault();
        nextButton.click();
      }
    }
  });
})();
